import { render, staticRenderFns } from "./WesError.vue?vue&type=template&id=4d8a0c66&scoped=true&"
import script from "./WesError.vue?vue&type=script&lang=js&"
export * from "./WesError.vue?vue&type=script&lang=js&"
import style0 from "./WesError.vue?vue&type=style&index=0&id=4d8a0c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a0c66",
  null
  
)

export default component.exports